import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';

/** This component adds custom block styling to the course design guide */

@Component({
  selector: 'app-block-styling',
  templateUrl: './block-styling.component.html',
  styleUrls: ['../../rendered.component.scss', './block-styling.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockStylingComponent extends BaseScaffoldComponent implements OnInit {
  @Input() childview; /** renders view sub-components */
  @Output() openViewEvent = new EventEmitter<string>();
  @Output() openLinkEvent = new EventEmitter<string>();
  @Output() deleteDataEvent = new EventEmitter<any>();
  @Output() moveHandler = new EventEmitter<any>()
  width: 'auto'

  /**
   * Classes - a class to trigger updates on block styles
   * @extends BaseScaffoldComponent
   * @property {string} background - the item background
   * @property {string} alignment - the item alignment
   * @return {number} colors
   */

  get classes() {
    let classes = "";
    if (this.item.background_type === 'select') {
      if (this.item.background)
        classes += this.item.background;

    }
    if (this.item.alignment)
      classes += " " + this.item.alignment;
    if (this.item.classes)
      classes += " " + this.item.classes;
    return classes
  };
  colors = ["#b5424a", "#68899e", "#fe9e22", "#70357f", "#eaf04a", "#d3b13c", "#71eea6", "#a294d0", "#ee71e4", "#95ba3b", "#696969", "#7d6342"];


  constructor(public cdr: ChangeDetectorRef, public renderedService: RenderedService) { super(cdr, renderedService); }

  ngOnInit() {
  }
  /**
   * delete the item emitted
   * @fires delete
    */

  delete(item) {
    this.deleteDataEvent.emit(item)
  }
  /**
   * view the item emitted
   * @emits openView
   */
  openView(mode: any) {
    this.openViewEvent.emit(mode);
  }
  /**
   * link the item emitted
   * @emits openLink
   */

  openLink(mode: any) {
    this.openLinkEvent.emit(mode);
  }
  /**
   * move the item emitted
   * @emits openMove
   */
  openMove() {
    this.moveHandler.emit('move');
  }

  /**
   * @returns {number} - returns the width/height/background/alignment/radius/border/text-color styles
   */

  caclWidth() {
    let w = "width:" + this.item.width + ";"
    return w
  }

  caclHeight() {
    let w = "height:" + this.item.height + ";"
    return w
  }

  calcStyle() {
    let style = "";
    if (this.item.width) {
      style += this.caclWidth();
    }
    if (this.item.height) {
      style += this.caclHeight();
    }
    try {
      if (this.item.background_type === 'data' && this.item.value) {
        let index;
        if (typeof this.item.value == 'string') {
          if (!this.item.value.match(/\D/)) {
            index = parseInt(this.item.value);
          } else {
            index = this.item.value.charCodeAt(0) - 97;
          }
        }
        if (typeof this.item.value == 'number') {
          index = parseInt(this.item.value);
        }
        if (index && typeof index == 'number') {
          index = index % 19;
          let color = this.colors[index];
          style += "background-color:" + color + ";"
          style += "color:" + this.calculateTextColor(color) + ";"
        }
      } else if (this.item.background_type === 'manual') {
        style += "background-color:" + this.item.background_color + ";"
        style += "color:" + this.calculateTextColor(this.item.background_color) + ";"
      }
    } catch (e) {
      console.log(e);
    }
    if (this.item.border)
      style += "border:" + this.item.border + ";"
    if (this.item.text_color)
      style += "color:" + this.item.text_color + ";"
    if (this.item.is_bold)
      style += "font-weight:700;"
    if (this.item.is_italic)
      style += "font-style:italic;"
    if (this.item.radius)
      style += `border-radius:${this.item.radius}${this.item.radius_type||'px'};`
    if(this.item.padding_top_bottom||this.item.padding_sides){
      style+= `padding:${this.item.padding_top_bottom||0}px ${this.item.padding_sides||0}px;`
    }

    return style;
  }

  calculateTextColor(color) {
    let r, g, b;
    if (color.match(/\#/)) {
      if (color.lenght === 7) {
        r = parseInt(color.substr(1, 2), 16);
        g = parseInt(color.substr(3, 2), 16);
        b = parseInt(color.substr(5, 2), 16);
      } else {
        r = parseInt(color.substr(1, 1) + color.substr(1, 1), 16);
        g = parseInt(color.substr(2, 1) + color.substr(2, 1), 16);
        b = parseInt(color.substr(3, 1) + color.substr(3, 1), 16);
      }
    } else {
      let match = color.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
      r = match[1];
      g = match[2];
      b = match[3];
    }
    //console.log("RGB:", r, g, b)
    if (r && g && b) {
      let yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
   //   console.log(yiq);
      return (yiq >= 128) ? '#030303' : '#fdfdfd';
    }
    return '#030303';
  }

}
